import {ApiUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorsExportModal} from 'entities/monitor';
import {buildHttpMonitorsExportRequest} from 'features/http/lib/httpMonitorsExportRequest';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import HttpMonitorFiltersForm from '../HttpMonitorsFilters/HttpMonitorFiltersForm/HttpMonitorFiltersForm';

interface IHttpMonitorsExportModalProps {
    open: boolean,
    handleClose: () => void,
}

const HttpMonitorsExportModal: React.FC<IHttpMonitorsExportModalProps> = ({open, handleClose}) => (
    <MonitorsExportModal
        open={open}
        handleClose={handleClose}
        header={t`Экспорт сайтов`}
        path={ApiUrls.MONITORS_EXPORT}
        FiltersForm={HttpMonitorFiltersForm}
        buildRequest={buildHttpMonitorsExportRequest}
        countLabel={t`Экспортировано сайтов`}
        onExported={() => reachGoal(YM_GOALS.EXPORT_DATA_MONITOR)}
    />
);

export default HttpMonitorsExportModal;
